import React, { Component } from "react";

class DownloadPdfButton extends Component {
	static slug = "urm-download-pdf-button";
	render() {
		if (this.props.__render_download_pdf_button) {
			return (
				<div
					dangerouslySetInnerHTML={{
						__html: this.props.__render_download_pdf_button
					}}
				></div>
			);
		}
		return null;
	}
}

export default DownloadPdfButton;
